/** 학급 상점 아이템 카테고리 — 캐릭터 허브에서 사용하는 소모품 */
export const PET_CONSUMABLE_CATEGORY = 'petConsumable' as const;

/** 학급 상점 — 캐릭터 놀아주기 이용권 (쓰다듬기 등) */
export const PET_PLAY_TICKET_CATEGORY = 'petPlayTicket' as const;

export type PetConsumableCategory = typeof PET_CONSUMABLE_CATEGORY;
export type PetPlayTicketCategory = typeof PET_PLAY_TICKET_CATEGORY;

export type PetPlayActionType = 'stroke' | 'ball' | 'feather' | 'laser';

export interface PetItemEffect {
  hunger?: number;
  happiness?: number;
  energy?: number;
  health?: number;
  exp?: number;
  intimacy?: number;
}

export interface OwnedPetConsumable {
  uniqueKey: string;
  itemId: string;
  name: string;
  image?: string;
  petEffect?: PetItemEffect;
}

export interface OwnedPetPlayTicket {
  uniqueKey: string;
  itemId: string;
  name: string;
  image?: string;
  petPlayAction: PetPlayActionType;
}

export const isPetConsumableCategory = (category?: string): category is PetConsumableCategory =>
  category === PET_CONSUMABLE_CATEGORY;

export const isPetPlayTicketCategory = (category?: string): category is PetPlayTicketCategory =>
  category === PET_PLAY_TICKET_CATEGORY;

export const hasPetItemEffect = (effect?: PetItemEffect): boolean => {
  if (!effect) return false;
  return Object.values(effect).some((value) => typeof value === 'number' && value !== 0);
};
